/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authsignuploginlink4Inputs */



/**
* | output |
* | --- |
* | "Log In" |
*
* @param {Authsignuploginlink4Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authsignuploginlink4 = /** @type {((inputs?: Authsignuploginlink4Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authsignuploginlink4Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("Log In")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("Se connecter")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("Anmelden")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("登入")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("로그인")
	return /** @type {LocalizedString} */ ("ログイン")
});
export { authsignuploginlink4 as "authSignUpLoginLink" }